import { createAction, props } from '@ngrx/store';

import { OneTimePaySetup, OTPAnalyticsModel, OTPReviewData } from './one-time-pay-feature.models';

export const addOneTimePayBillAccount = createAction(
  '[OneTimePaySetup] Add OneTimePay Bill Account',
  props<{ setups: OneTimePaySetup }>()
);

export const updatePaymentAmount = createAction(
  '[OneTimePaySetup] Update OneTimePay Payment Amount',
  props<{ billAccountNumber: string; selectedPaymentAmount: number }>()
);

export const removeOneTimePayBillAccount = createAction(
  '[OneTimePaySetup] Remove OneTimePay Bill Account',
  props<{ billAccountNumber: string }>()
);

export const loadOneTimePays = createAction(
  '[OneTimePaySetup] Load OneTimePays',
  props<{ setups: OneTimePaySetup[] }>()
);

export const setOneTimePayCancelPath = createAction(
  '[OneTimePaySetup] Set Cancel Path',
  props<{ url: string }>()
);

export const setOneTimePayOperation = createAction(
  '[OneTimePaySetup] Set Operation',
  props<{ operation: string }>()
);

export const setSelectedAccounts = createAction(
  '[OneTimePaySetup] Set Selected Accounts',
  props<{ selectedAccounts: string[] }>()
);

export const setOneTimePayReviewInfo = createAction(
  '[OneTimePaySetup] Set OneTimePay Review page info',
  props<{
    reviewData: OTPReviewData[];
  }>()
);

export const setOneTimePayReviewInfoForEdit = createAction(
  '[OneTimePaySetup] Set OneTimePay Review page info for Edit',
  props<{
    reviewData: OTPReviewData[];
  }>()
);

export const sendOtpAnalytics = createAction(
  '[OneTimePaySetup] send OTP analytics',
  props<{ payload: OTPAnalyticsModel }>()
);

export const setOneTimePayPaymentAmtAnalyticsInfo = createAction(
  '[OneTimePaySetup] Set Payment Amount Analytics Information',
  props<{ paymentAmtForAnalytics: string }>()
);

export const setOneTimePayPaymentDateAnalyticsInfo = createAction(
  '[OneTimePaySetup] Set Payment Date Analytics Information',
  props<{ paymentDateForAnalytics: string }>()
);

export const submitOTP = createAction('[OneTimePaySetup] Submit OneTimePayment');

export const editOTP = createAction('[OneTimePaySetup] Edit OneTimePayment');

export const resetOneTimePaySetup = createAction('[OneTimePaySetup] Reset OneTimePay Setup');

export const goToCancelPath = createAction('[OneTimePaySetup] Go To Cancel Path');

export const goToMakeAnotherPayment = createAction('[OneTimePaySetup] Go To Make Another Payment');

export const goToBilling = createAction('[OneTimePaySetup] Go To Billing');

export const removeOneTimePayBillAccounts = createAction(
  '[OneTimePaySetup] Remove OneTimePay Bill Accounts'
);

export const routeToReviewForEdit = createAction(
  '[OneTimePaySetup] Go To Review for Edit',
  props<{ paymentId: string }>()
);

export const leaveOTPFlow = createAction(
  '[OneTimePaySetup] Leave OneTimePay Flow',
  props<{ billAccountNumber?: string; id?: string }>()
);

export const storePaymentId = createAction(
  '[OneTimePaySetup] Store Payment Id',
  props<{ paymentId: string }>()
);

export const storePaymentErrorCode = createAction(
  '[OneTimePaySetup] Store Error Code',
  props<{ paymentErrorCode: string }>()
);
